import { useStatContext } from '@/creditflowresearch/application/ArticlesAndStats/Stat';
import RelatedData from '@/creditflowresearch/ui/components/creditFlow/common/RelatedData';
import RelatedDataSection from '@/creditflowresearch/ui/components/creditFlow/common/RelatedData/RelatedDataSection';

const StatRelatedData = () => {
  const {
    stat,
    downloadAttachment,
  } = useStatContext();
  const shouldRenderRelatedData = stat.attachment.length > 0;

  if (!shouldRenderRelatedData) {
    return null;
  }
  return (
    <RelatedData>
      <RelatedDataSection
        label="Attachment"
        collection={ stat.attachment }
        onClick={ downloadAttachment }
        dataTest="articleAttachments"
        isDownload
      />
    </RelatedData>
  );
};

export default StatRelatedData;
